import {Component, Input, OnInit} from '@angular/core';
import { ModalController} from '@ionic/angular';
import {ActivatedRoute} from "@angular/router";
import {OfferInfo} from "~/app/core/model/offer-info";
import {CoreService} from "~/app/core/core.service";
import {AddressInfo} from "~/app/core/model/address-info";
import {LocationInfo} from "~/app/core/model/location-info";
import {AddressDistance} from "~/app/core/model/address-distance";
import * as moment from "moment";
import {InteractionOffer} from "~/app/core/model/interaction/interaction-offer";
import {InteractionService} from "~/app/core/interaction.service";

@Component({
  selector: 'app-modal',
  templateUrl: './redeemDialog.component.html',
  styleUrls: ['./redeemDialog.component.scss'],
})

export class RedeemDialogComponent implements OnInit {

  @Input() offerId: number;
  @Input() offer: OfferInfo;
  nearestAddress: AddressInfo;
  nearestAddressDistance: number = null;
  addressesWithDistance: Array<AddressDistance> = [];
  longitude: number = null;
  latitude: number = null;
  findingLocation: boolean = false;
  userAtLocation: AddressInfo = null;
  interval = null
  linkError: boolean = false;

  constructor(
    public modalCtrl: ModalController,
    private readonly route: ActivatedRoute,
    private readonly core: CoreService,
    private readonly interactionService: InteractionService,
  ) {
  }

  ngOnInit() {
    if (this.offer.onlineOnly) {
      setTimeout(() => {
        this.redeemOnlineOffer(this.offer.onlineRedeemUrl);
      }, 3000);
    }
    else {
      this.loadOffer();
      // periodically check the user's location
      this.interval = setInterval(() => this.checkUserIsAtBusinessLocation(), 5000);
    }
  }

  async redeemOnlineOffer(url) {
    await fetch(url, {method: "get"})
      .then(response => {
        if (response.status < 400) {
          this.redeem();
          setTimeout(()=>{
            window.open(url, '_top');
          });
          setTimeout(() => this.dismiss(), 5000);
        } else
          this.linkError = true;
      })
      .catch(error => {
        this.redeem();
        // TODO
        // unfortunately, we can't tell if this was a CORS error or a bad url, so we'll just ignore it and try to open the link anyway.
        setTimeout(()=>{
          window.open(url, '_top');
        });
        setTimeout(() => this.dismiss(), 5000);
      });
  }

  private loadOffer() {
    console.log(this.offerId);
    this.offer = this.core.api.offers_getOffer(Number(this.offerId));
    this.findNearestLocation();
  }

  redeem() {
    let data: InteractionOffer = {
      pgShowCashierCount: 1
    };
    this.interactionService.interactOffer(Number(this.offerId), data);
    let addressId = this.userAtLocation ? this.userAtLocation.addressId : null;
    this.core.api.offers_redeemOffer(this.offerId, addressId)
      .then(result => {
        console.log("Redeem result:");
        console.log(result)
      });
    this.offer.redeemedDate = moment().format("YYYY-MM-DD");
    this.modalCtrl.dismiss(this.offerId);
  }

  userIsAtBusinessLocation(): boolean {
    return this.userAtLocation != null;
  }

  calculateDistance(address: AddressInfo): number {
    const distance = this.milesAwayPrecise(address);
    if (distance) {
      return distance > 1 ? Math.round(distance) : Math.round(distance * 10) / 10;
    }
    else if (distance === 0)
      return 0;
    return null;
  }

  milesAwayPrecise(address: AddressInfo): number {
    if (this.hasMilesAway(address)) {
      const distance = LocationInfo.milesAway(
        { longitude: address.longitude, latitude: address.latitude },
        { longitude: this.longitude, latitude: this.latitude }
      );
      console.log(address.city + " distance: " + distance);
      return distance;
    }
    return null;
  }

  hasMilesAway(address: AddressInfo): boolean {
    return !!address.latitude && !!address.longitude && !!this.longitude && !!this.latitude;
  }

  findNearestLocation() {
    this.findingLocation = true;
    this.core.api.location_getLocationInfo().then(locationInfo => {
        let addresses = [];
        let _addresses: Array<AddressInfo> = [];
        this.longitude = locationInfo.longitude;
        this.latitude = locationInfo.latitude;
        _addresses = this.offer.addresses;

        this.findingLocation = false;
        for (let address of _addresses) {
            let calculatedDistance = this.calculateDistance(address);
          if (this.nearestAddressDistance == null || calculatedDistance < this.nearestAddressDistance) {
            this.nearestAddressDistance = calculatedDistance;
            this.nearestAddress = address;
          }
          addresses.push({address, distance: calculatedDistance});
        }
        addresses.sort((a, b) => {
          if (a.distance === b.distance) return 0;
          else if (a.distance < b.distance) return -1;
          else return 1;
        });
        for (let address of addresses) {
          this.addressesWithDistance.push({address: address.address, distance: address.distance});
        }
      }, (error) => {
        console.log("failed to get location");
        // location services
        this.userAtLocation = this.offer.addresses[0];
        this.findingLocation = false;
      });
    }

  getMapUrl(address: AddressInfo) {
    let urlScheme = 'maps';
    if /* if we're on iOS, open in Apple Maps */
    ((navigator.platform.indexOf("iPhone") != -1) || (navigator.platform.indexOf("iPad") != -1) || (navigator.platform.indexOf("iPod") != -1))
      urlScheme = "maps";
    else
      urlScheme = "https";
    // return urlScheme + "://maps.google.com/maps?daddr="+this.nearestAddress.latitude+","+this.nearestAddress.longitude+"&amp;ll=";
    return urlScheme + "://maps.google.com/maps/dir/"+this.latitude+","+this.longitude+"/"+address.latitude+","+address.longitude;
  }

  showMap(address: AddressInfo) {
    window.open(this.getMapUrl(address), "_blank");
  }

  checkUserIsAtBusinessLocation() {
    for (let address of this.addressesWithDistance) {
      let d = this.calculateDistance(address.address);
      if (d != null && d <= .01) {
        this.userAtLocation = address.address;
        clearInterval(this.interval);
        break;
      }
      else
        this.userAtLocation = null;
    }
  }

  dismiss() {
    this.modalCtrl.dismiss();
  }

}
